usuario.component('usuario.usuarioComponent', {
    templateUrl: 'usuario/usuario.html',
    controller: 'usuario.usuarioController',
    controllerAs: '$ctrl'
});

usuario.controller('usuario.usuarioController', ['$rootScope', '$state', '$scope', 'coreLanguage', 'coreFb', 'coreDialog', '$element', function($rootScope, $state, $scope, $text, $fb, $dialog, $element){
    const $ctrl = this;
    $scope.$text = $text;

    $ctrl.loadingImg = false;
    $ctrl.userProducts = [];

    const _getUser=(idArea)=>{
        $fb.db.get(`cad_usuarios/${idArea}`).then(doc=>{
            $ctrl.usuario = doc;
            $state.params.showGlobalLoading = false;

            $ctrl.loadingCert=true;

            ///Chamar a função para obter dados de progresso
            return $fb.functions.invoke('aulas_listProgress');

        }).then(list=>{
            $ctrl.userProducts = list;
            $ctrl.loadingCert=false;

        }).catch(e=>{
            console.log(e);
        });
    };

    const _closeModal=()=>{
        $ctrl.modal.tipo = false;
        $ctrl.modal.show = false;
        $ctrl.modal.loading = false;
    };

    const _updateUser=(dados)=>{
        console.log('Submited', dados);
        
        if(dados.email){
            ///Function de alteração do email
            _closeModal();

        }else{
            $fb.db.update($ctrl.usuario.path, dados)
            .then(dados=>{
                $state.reload();
            });
        }
    };

    $ctrl.uploadFoto=(event)=>{
        const file = event.target.files[0]
        const ext = file.name.split('.').pop();

        if (!['png', 'jpg', 'jpeg', 'webp', 'svg'].includes(ext.toLowerCase())) {
            return
        }

        $ctrl.loadingImg=true;

        $fb.storage.upload(`/usuarios/${$ctrl.usuario.id}`, event.target.files[0]).then(url => {
            $fb.db.update($ctrl.usuario.path, {fotoUrl: url});
            $ctrl.usuario.data.fotoUrl = url
            $ctrl.loadingImg=false;
        })
    };

    $ctrl.logout=()=>{
        $fb.auth.logout().then(()=>{ $state.reload(); });
        if(window.$chatwoot){ window.$chatwoot.reset(); }
    };

    $ctrl.editEmail=()=>{
        $ctrl.modal.title = $text.change+' email';
        $ctrl.modal.tipo = 'email';
        $ctrl.modal.show = true;
    };
    
    $ctrl.editPhone=()=>{
        $ctrl.modal.title = $text.change+' '+$text.phone;
        $ctrl.modal.tipo = 'telefone';
        $ctrl.modal.show = true;
    };

    $ctrl.editEndereco=()=>{
        $ctrl.modal.title = $text.change+' '+$text.account.address;
        $ctrl.modal.tipo = 'endereco';
        $ctrl.modal.show = true;
    };

    $ctrl.editPass=()=>{
        $fb.auth.resetPassword($ctrl.usuario.data.email).then(okay=>{
            $dialog.show($text.changePass, $text.infoRecoverLink, 'Ok', '');
        });
    };

    $ctrl.openCertificado=(produto)=>{
        if(!produto.hasCertificado){
            return;
        }

        $fb.db.get(`cad_produtos/${produto.codProduto}`).then(doc=>{
            $ctrl.certificado = {
                ...doc.data.certificado,
                nome:produto.nome
            };

            $ctrl.showModalCertificado=true;
            $ctrl.renderCertificado();
        });

    };

    $ctrl.closeCertificado=()=>{
        $ctrl.showModalCertificado = false;
        $ctrl.certificado={};
    };

    $ctrl.saveCertificado = () => {
        const canvasElement = $element[0].querySelector('.certificado-container');

        const certificadoUrl = canvasElement.toDataURL("image/png").replace("image/png", "image/octet-stream");

        const link = document.createElement("a");
        link.href = certificadoUrl;
        link.download = `Certificado ${$ctrl.certificado.nome}.png`;
        link.click();
    };
    
    $ctrl.renderCertificado = () => {
        const canvasImage = new Image();
        canvasImage.crossOrigin="anonymous"

        const renderElements = () => {
            const canvasElement = $element[0].querySelector('.certificado-container');
            const canvasContext = canvasElement.getContext('2d');

            const canvasWidth = canvasImage.width;
            const canvasHeight = canvasImage.height * 1.04;

            canvasContext.canvas.width = canvasWidth;
            canvasContext.canvas.height = canvasHeight;

            canvasContext.fillStyle = 'black';
            canvasContext.fillRect(0, 0, canvasWidth, canvasHeight);

            canvasContext.drawImage(canvasImage, 0, 0);

            canvasContext.fillStyle = 'white';
            canvasContext.textBaseline = 'bottom';
            canvasContext.textAlign = 'center';
            canvasContext.font = `${canvasImage.height * .02}px Montserrat`;

            //const dataProgresso = new Date($ctrl.hasCertificado.progressoData._seconds * 1000);
            const dataProgresso = new Date();
            const dataEmissao = $filter('date')(dataProgresso, 'dd/MM/yy');
            const footerMessage = `Emitido em ${dataEmissao} por Fábrica Office`;
            canvasContext.fillText(footerMessage, canvasWidth * .5, canvasHeight * 0.99);

            canvasContext.fillStyle = ($ctrl.certificado.textColor ?? '#000000');
            canvasContext.textBaseline = ($ctrl.certificado.textBaseline ?? 'middle');
            canvasContext.textAlign = ($ctrl.certificado.textAlign ?? 'center');

            const relativeTextSize = canvasImage.width * ($ctrl.certificado.textSize ?? 50) * .0015;
            const relativePosX = canvasImage.width * ($ctrl.certificado.posX ?? 50) * .01;
            const relativePosY = canvasImage.height * ($ctrl.certificado.posY ?? 50) * .01;

            canvasContext.font = `${relativeTextSize}px Montserrat`;
            canvasContext.fillText($fb.auth.getUser().displayName, relativePosX, relativePosY);
        }

        canvasImage.addEventListener('load', renderElements, false);
        canvasImage.src = $ctrl.certificado.imgUrl;
    };

    $ctrl.modal = {
        tipo: false,
        show: false,
        confirm: _updateUser,
        close: _closeModal
    };

    $ctrl.$onInit = () => {
        let idUsuario = $fb.auth.getIdToken().claims.idUsuario;
        $rootScope.idAreaMembros = $fb.auth.getIdToken().claims.idAreaMembros;

        _getUser(idUsuario);
    };

}]);